import styled from 'styled-components';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { colorVariables } from 'theme/variables';
import { embedWrapper } from './mediaQueries';

export const CollapsibleStyled = styled.div`
  padding: 0 10px 0 20px;
  ${embedWrapper};
`;

export const OuterContainer = styled.div`
  overflow: hidden;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 24px;
`;

export const TriggerButton = styled.button`
  position: relative;
  height: 20px;
  width: 100%;
  text-decoration: none;
  padding: 0;
  background: transparent;
  color: white;
  border: none;
`;

export const TriggerButtonWrap = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  width: 100%;
  height: 100%;
`;

export const StyledIcon = styled(Icon)`
  margin-right: 3px;
  transform: ${(props) => (props.active ? 'rotate(270deg)' : 'rotate(180deg)')};

  ${TriggerButton}:hover & {
    fill: ${colorVariables.blue_navyblue};
  }
`;

export const StyledText = styled(Text)`
  ${TriggerButton}:hover & {
    color: ${colorVariables.blue_navyblue};
  }
`;
